/* eslint-disable array-callback-return */
import React, { useContext } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import remove_icon from '../Assets/cart_cross_icon.png';
import { useNavigate } from 'react-router-dom';

const CartItems = () => {
  const {
    getTotalCartAmount,
    all_product,
    CartItems,
    removeFromCart,
    setCartItems, // تأكيد الوصول إلى setCartItems
  } = useContext(ShopContext);
  const navigate = useNavigate();

  const removeEntireItem = (itemId) => {
    const updatedCart = { ...CartItems };
    for (const size in updatedCart[itemId]) {
      updatedCart[itemId][size] = 0;
    }
    setCartItems(updatedCart); // الآن يعمل بفضل الإضافة في ShopContext
    if (localStorage.getItem('auth-token')) {
      Object.keys(CartItems[itemId]).forEach((size) => {
        removeFromCart(itemId, size); // إرسال طلب للـ Backend لكل حجم
      });
    }
  };

  return (
    <div className="cartitems">
      <div className="cartitems-format-main">
        <p>Products</p>
        <p>Title (Sizes)</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      {all_product.map((e) => {
        const sizes = CartItems[e.id];
        const hasItems = Object.values(sizes).some(quantity => quantity > 0);
        if (hasItems) {
          const totalItemPrice = e.new_price * Object.values(sizes).reduce((sum, q) => sum + q, 0);
          return (
            <div key={e.id}>
              <div className="cartitems-format cartitems-format-main">
                <img
                  src={e.image_urls?.[0] || e.image || 'https://via.placeholder.com/300'}
                  alt={e.name}
                   className="carticon-product-icon"
                  />

                <p>{e.name}</p>
                <p>${e.new_price}</p>
                <div>
                  {Object.entries(sizes).map(([size, quantity]) => {
                    if (quantity > 0) {
                      return (
                        <div key={size} style={{ display: 'flex', alignItems: 'center', margin: '2px 0' }}>
                          <p>{quantity} x {size}</p>
                          <img
                            src={remove_icon}
                            alt="Remove"
                            className="cartitems-remove-icon"
                            onClick={() => removeFromCart(e.id, size)}
                            style={{ marginLeft: '10px', cursor: 'pointer', width: '15px', height: '15px' }}
                          />
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
                <p>${totalItemPrice.toFixed(2)}</p>
                <button
                  onClick={() => removeEntireItem(e.id)}
                  className="cartitems-remove-button"
                  style={{ cursor: 'pointer', background: 'none', border: 'none', padding: '0' }}
                >
                  <img src={remove_icon} alt="Remove All" style={{ width: '15px', height: '15px' }} />
                </button>
              </div>
              <hr />
            </div>
          );
        }
        return null;
      })}
      <div className="cartitems-down">
        <div className="cartitems-total">
          <h1>Cart Totals</h1>
          <div>
            <div className="cartitems-total-item">
              <p>Subtotal</p>
              <p>${getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <p>Shipping Free</p>
              <p>Free</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <h3>Total</h3>
              <h3>${getTotalCartAmount()}</h3>
            </div>
          </div>
          <button onClick={() => navigate('/payment')}>Proceed to Checkout</button>
        </div>
        <div className="cartitems-promocode">
          <p>If you have a promo code, enter it here</p>
          <div className="cartitems-promobox">
            <input type="text" placeholder="Promo Code" />
            <button>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItems;
